import axios from "axios";
import { getSessionId } from "../../../../utils/tokenHandlers";

export const deleteDocumentRecord = (docId: number) => {
  const sessionid = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/delete/many/tradexwbench.customer_kyc_document/`,
      {
        params: {
          filter: [["attachment_ids", "=", docId]],
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionid}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
